// vim: set ts=2 sts=2 sw=2 et:

// La web guarda el país como código ISO y el bundle lo manda con el nombre de `country-region-data`, en inglés
// ("Peru", "Venezuela, Bolivarian Republic of"); sin país manda "ARGENTINA". En pantalla va en español.
const SPANISH_NAMES: Record<string, string> = {
  alemania: "Alemania",
  andorra: "Andorra",
  argentina: "Argentina",
  bolivia: "Bolivia",
  brasil: "Brasil",
  brazil: "Brasil",
  canada: "Canadá",
  chile: "Chile",
  colombia: "Colombia",
  "costa rica": "Costa Rica",
  cuba: "Cuba",
  "dominican republic": "República Dominicana",
  ecuador: "Ecuador",
  "el salvador": "El Salvador",
  espana: "España",
  "equatorial guinea": "Guinea Ecuatorial",
  "estados unidos": "Estados Unidos",
  france: "Francia",
  francia: "Francia",
  germany: "Alemania",
  guatemala: "Guatemala",
  "guinea ecuatorial": "Guinea Ecuatorial",
  honduras: "Honduras",
  italia: "Italia",
  italy: "Italia",
  mexico: "México",
  nicaragua: "Nicaragua",
  panama: "Panamá",
  paraguay: "Paraguay",
  peru: "Perú",
  portugal: "Portugal",
  "puerto rico": "Puerto Rico",
  "reino unido": "Reino Unido",
  "republica dominicana": "República Dominicana",
  spain: "España",
  "united kingdom": "Reino Unido",
  "united states": "Estados Unidos",
  uruguay: "Uruguay",
  venezuela: "Venezuela",
};

const normalize = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const titleCase = (value: string): string =>
  value.toLowerCase().replace(/(^|\s)(\S)/g, (_match, space: string, letter: string) => space + letter.toUpperCase());

export const countryLabel = (raw: string | undefined): string | null => {
  const value = raw?.trim();
  if (!value) return null;
  // "Venezuela, Bolivarian Republic of" → "Venezuela": la parte oficial no entra en pantalla.
  const short = value.split(",")[0].trim();
  const known = SPANISH_NAMES[normalize(value)] ?? SPANISH_NAMES[normalize(short)];
  if (known !== undefined) return known;
  return short === short.toUpperCase() ? titleCase(short) : short;
};
